$(document).ready(function(){
  $('.rezepte-carousel').owlCarousel({
    items:2,
    loop:true,
    margin:20,
    nav:true,
    dots:false,
    navText: [
        "<img src='/cdn/shop/t/10/assets/Component-left.png' alt='Previous'>", 
        "<img src='/cdn/shop/t/10/assets/Component-right.png' alt='Next'>"
      ], 
      responsive:{
          1050:{
              items:2
          },
          800:{
              items:2
          },
          600:{
              items:2
          },
          0:{
              items:2
          }
      }
  });
});
$(document).ready(function(){
  $('.review-carousel').owlCarousel({
    items:4,
    loop:true,
    margin:20,
    nav:true,
    dots:false,
    navText: [
        "<img src='/cdn/shop/t/10/assets/Component-left.png' alt='Previous'>", 
        "<img src='/cdn/shop/t/10/assets/Component-right.png' alt='Next'>"
      ],
      responsive:{
          1050:{
              items:4
          },
          800:{
              items:3
          },
          600:{
              items:2
          },
          0:{
              items:1
          }
      }
  });
});
$(document).ready(function(){
  $('.pp-carousel').owlCarousel({
    items:2,
    loop:true,
    margin:20,
    nav:false,
    dots:false,
      responsive:{
          1050:{
              items:4
          },
          800:{
              items:4
          },
          600:{
              items:3
          },
          0:{
              items:1
          }
      }
  });
});